<div class="current-exports-panel">
  <div class="panel-header">
    <h3>{{ 'files.current-exports.title' | translate }}</h3>
    <button type="button" class="btn-close" (click)="close()" aria-label="Close">×</button>
  </div>

  <div *ngIf="loading && !jobs.length" class="panel-body loading-state">
    <span class="spinner"></span>
    <span>{{ 'files.current-exports.loading' | translate }}</span>
  </div>

  <div *ngIf="!loading && !jobs.length && !errorMessage" class="panel-body empty-state">
    {{ 'files.current-exports.empty' | translate }}
  </div>

  <div *ngIf="errorMessage" class="panel-body error-state">
    {{ errorMessage }}
  </div>

  <ul *ngIf="jobs.length" class="panel-body job-list">
    <li
      *ngFor="let job of jobs; trackBy: trackByJobId"
      class="job-row"
      [class.downloaded]="isDownloaded(job.jobId)">
      <div class="job-meta">
        <div class="job-status-row">
          <span class="job-status" [attr.data-status]="job.status">
            {{ statusLabelKey(job.status) | translate }}
          </span>
          <span *ngIf="isDownloaded(job.jobId)" class="downloaded-pill">
            {{ 'files.current-exports.downloaded-badge' | translate }}
          </span>
        </div>
        <span class="job-size">
          {{ job.fileCount }} {{ 'files.current-exports.files-label' | translate }}
          · {{ humanReadableSize(job.totalBytes) }}
        </span>
      </div>

      <div class="job-actions">
        <button
          *ngIf="job.status === STATUS.COMPLETED && !isDownloading(job.jobId)"
          type="button"
          class="btn btn-primary-light"
          (click)="download(job)">
          {{ 'files.current-exports.download' | translate }}
        </button>
        <span
          *ngIf="isDownloading(job.jobId)"
          class="downloading-indicator">
          <span class="downloading-spinner"></span>
          {{ 'files.current-exports.downloading' | translate }}
        </span>
        <button
          type="button"
          class="btn-remove"
          [title]="'files.current-exports.remove' | translate"
          (click)="remove(job)"
          aria-label="Remove">×</button>
      </div>
    </li>
  </ul>

  <p *ngIf="jobs.length >= LIST_CAP" class="panel-footer">
    {{ 'files.current-exports.showing-max' | translate:{ max: LIST_CAP } }}
  </p>
</div>
